import {
  httpGet,
  httpPost,
  httpPatchMerge,
  httpPatch,
  httpDelete,
} from './http'
import type { TEntityId } from '~/types/models'
import type { IOpportunityMSService } from '~/types/opportunity/models'

const apiEntityPath = '/api/opportunitymsservices'

export async function getCompanyFromOpportunityMSService(id: TEntityId) {
  const callingMn = getCompanyFromOpportunityMSService.name
  const apiPath = `${apiEntityPath}/${id}/company`
  return httpGet<IOpportunityMSService>({ callingMn, apiPath })
}

export async function createOpportunityMSService(
  entity: IOpportunityMSService
) {
  const callingMn = createOpportunityMSService.name
  const apiPath = apiEntityPath
  return httpPost<IOpportunityMSService>({
    callingMn,
    apiPath,
    entity,
    asyncOptions: { doAsync: true },
  })
}

export async function updateOpportunityMSService(
  entityData: Partial<IOpportunityMSService> | Partial<IOpportunityMSService>[],
  id?: TEntityId
) {
  const callingMn = updateOpportunityMSService.name
  if (Array.isArray(entityData)) {
    const apiPath = `${apiEntityPath}`
    return httpPatch<Partial<IOpportunityMSService>[]>({
      callingMn,
      apiPath,
      entityData,
      asyncOptions: { doAsync: true },
    })
  }
  const apiPath = `${apiEntityPath}/${id}`
  return httpPatchMerge<Partial<IOpportunityMSService>>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteOpportunityMSService(
  entityData: IOpportunityMSService | IOpportunityMSService[]
) {
  const callingMn = deleteOpportunityMSService.name
  const apiPath = apiEntityPath
  return httpDelete<IOpportunityMSService | IOpportunityMSService[]>({
    callingMn,
    apiPath,
    entityData,
  })
}
